/**
 * Anpassningsbar bilaga (clean bilaga) — ADR-0061.
 *
 * Frame-less: no parties, no signing, no form number. The whole body is the
 * contract's own custom sections, numbered 1..N. It follows the signed avtal
 * it is attached to, so it has no signing mode of its own.
 */
import { COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
const DEFAULT_TITLE = 'Bilaga';
const titleFrom = (values, fallback) => typeof values.document_title === 'string' && values.document_title.trim() !== ''
    ? values.document_title.trim()
    : fallback;
export const cleanBilagaV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: 'clean_bilaga',
    documentVersion: 'v1',
    title: titleFrom(values, DEFAULT_TITLE),
    locale: 'sv-SE',
    meta: {
        category: 'Övriga avtal',
        shortTitle: 'Anpassningsbar bilaga',
        numberStyle: 'paragraph',
        description: 'En tom bilaga som du fyller med eget innehåll. Bifogas valfritt avtal ' +
            'och har ingen egen signering — den följer med det signerade avtalet.',
        status: 'active',
        attachableTo: ['*'],
        titleFromValueKey: 'document_title',
        defaultCustomSections: [{ title: 'Innehåll' }],
        partySlots: [],
    },
    values,
    blocks: [
        {
            instanceId: 'letterhead',
            blockRef: 'clean_bilaga.letterhead@v1',
            slot: 'letterhead',
            input: { default_title: DEFAULT_TITLE },
        },
        { instanceId: 'footer', blockRef: 'common.page-footer@v1', slot: 'footer', input: {} },
        { instanceId: 'custom-sections', blockRef: 'clean_bilaga.custom-sections@v1', input: {} },
    ],
});
//# sourceMappingURL=clean_bilaga.js.map